import { createFileRoute } from '@tanstack/react-router'
import IntegrationsPage from '@/pages/integrations'
import { buildHead } from '@/shared/seo/seo-config'
import { redirectIfPublicPageHidden } from '@/shared/lib/hidden-public-pages'

export const Route = createFileRoute('/$lang/integrations')({
  beforeLoad: ({ params }) =>
    redirectIfPublicPageHidden('integrations', params.lang),
  head: ({ params }) => buildHead('integrations', params.lang),
  component: IntegrationsPage,
  staticData: { layout: 'public' },
})
